import React, { useState, useEffect, useRef } from 'react'
import { updateTicket, fetchTickets, fetchCities, uploadPhoto, uploadRouteFile, fetchCandidateTasks, addTask, updateTask } from '../lib/api'
import MoscowPipeline from './MoscowPipeline'
import MoscowDocuments from './MoscowDocuments'
import { CitizenshipInput } from './CandidateModal'

const TIMEZONES = [
{ label: 'Кабо-Верде (UTC-1)', value: 'Atlantic/Cape_Verde' },
  { label: 'Бразилиа (UTC-3)', value: 'America/Sao_Paulo' },
  { label: 'Буэнос-Айрес (UTC-3)', value: 'America/Argentina/Buenos_Aires' },
  { label: 'Сантьяго (UTC-3/-4)', value: 'America/Santiago' },
  { label: 'Каракас (UTC-4)', value: 'America/Caracas' },
  { label: 'Богота (UTC-5)', value: 'America/Bogota' },
  { label: 'Лима (UTC-5)', value: 'America/Lima' },
  { label: 'Мехико (UTC-6)', value: 'America/Mexico_City' },{ label: 'Лондон (UTC+0/+1)', value: 'Europe/London' },  { label: 'Берлин (UTC+1/+2)', value: 'Europe/Berlin' },
  { label: 'Лагос (UTC+1)', value: 'Africa/Lagos' },
  { label: 'Каир (UTC+2)', value: 'Africa/Cairo' },
  { label: 'Харare (UTC+2)', value: 'Africa/Harare' },
  { label: 'Йоханнесбург (UTC+2)', value: 'Africa/Johannesburg' },
  { label: 'Найроби (UTC+3)', value: 'Africa/Nairobi' },
  { label: 'Аддис-Абеба (UTC+3)', value: 'Africa/Addis_Ababa' },
  { label: 'Москва (UTC+3)', value: 'Europe/Moscow' },
  { label: 'Стамбул (UTC+3)', value: 'Europe/Istanbul' },
  { label: 'Дубай (UTC+4)', value: 'Asia/Dubai' },
  { label: 'Дели (UTC+5:30)', value: 'Asia/Kolkata' },
  { label: 'Астана / Омск (UTC+6)', value: 'Asia/Almaty' },
  { label: 'Бангкок (UTC+7)', value: 'Asia/Bangkok' },
  { label: 'Манила (UTC+8)', value: 'Asia/Manila' },
  { label: 'Гонконг (UTC+8)', value: 'Asia/Hong_Kong' },
  { label: 'Пекин (UTC+8)', value: 'Asia/Shanghai' },
  { label: 'Токио (UTC+9)', value: 'Asia/Tokyo' },
  { label: 'Сидней (UTC+10/+11)', value: 'Australia/Sydney' },
]

export function LocationModal({ mode, initialData, onSave, onDelete, onClose }) {
  const [cities, setCities] = useState([])
  const [form, setForm] = useState({
    city_id: '',
    name: '',
    icon: '📍',
    lat: '',
    lng: '',
    timezone: 'Europe/Moscow',
    region: initialData?.region || 'АФРИКА',
    ...initialData,
  })
  const [saving, setSaving] = useState(false)
  const [geocoding, setGeocoding] = useState(false)

  useEffect(() => {
    fetchCities().then(setCities).catch(() => {})
  }, [])

  function set(field, value) { setForm(f => ({ ...f, [field]: value })) }

  function handleCitySelect(cityId) {
    const city = cities.find(c => c.id === cityId)
    if (!city) { set('city_id', ''); return }
    setForm(f => ({ ...f, city_id: city.id, name: city.name, timezone: city.timezone || f.timezone }))
    // Auto-geocode
    fetch(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(city.name)}&format=json&limit=1`,
      { headers: { 'Accept-Language': 'ru', 'User-Agent': 'LogisticsApp/1.0' } })
      .then(r => r.json())
      .then(data => {
        if (data && data.length > 0) {
          setForm(f => ({ ...f, lat: parseFloat(data[0].lat).toFixed(4), lng: parseFloat(data[0].lon).toFixed(4) }))
        }
      }).catch(() => {})
  }

  async function handleSubmit(e) {
    e.preventDefault()
    if (!form.name.trim()) return
    setSaving(true)
    await onSave({
      ...form,
      lat: form.lat !== '' ? parseFloat(form.lat) : null,
      lng: form.lng !== '' ? parseFloat(form.lng) : null,
    })
    setSaving(false)
  }

  return (
    <div className="modal-backdrop">
      <div className="modal modal-sm" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{mode === 'add' ? 'Новая локация' : 'Редактировать локацию'}</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={handleSubmit} className="modal-form">
          {mode === 'add' ? (
            <label>Город *
              <select required value={form.city_id} onChange={e => handleCitySelect(e.target.value)}
                style={{ fontSize: 14 }}>
                <option value="">— выберите из справочника —</option>
                {cities.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
              {cities.length === 0 && <p style={{ fontSize: 12, color: '#E24B4A', marginTop: 4 }}>Справочник городов пуст. Добавьте города через 🌍 Города.</p>}
            </label>
          ) : (
            <label>Название
              <input value={form.name} onChange={e => set('name', e.target.value)} />
            </label>
          )}
          <label>Иконка
            <input value={form.icon} onChange={e => set('icon', e.target.value)} maxLength={2} style={{ width: 70 }} />
          </label>
          {form.timezone && (
            <div style={{ fontSize: 12, color: '#888', marginBottom: 8 }}>
              Часовой пояс: <strong>{form.timezone}</strong> (из справочника городов)
            </div>
          )}
          <div className="form-section-label">Координаты для карты</div>
          {geocoding && <p style={{ fontSize: 12, color: '#888' }}>⏳ Определяем координаты...</p>}
          <div className="row-2">
            <label>Широта
              <input type="number" step="0.0001" value={form.lat} onChange={e => set('lat', e.target.value)} placeholder="41.01" />
            </label>
            <label>Долгота
              <input type="number" step="0.0001" value={form.lng} onChange={e => set('lng', e.target.value)} placeholder="28.98" />
            </label>
          </div>
          <p className="hint">Координаты заполняются автоматически при выборе города</p>
          <div className="modal-actions">
            {mode === 'edit' && (
              <button type="button" className="btn btn-danger" onClick={() => onDelete(initialData.id)}>Удалить</button>
            )}
            <button type="button" className="btn btn-outline" onClick={onClose}>Отмена</button>
            <button type="submit" className="btn btn-primary" disabled={saving || (mode === 'add' && !form.city_id)}>
              {saving ? 'Сохранение...' : mode === 'add' ? 'Добавить' : 'Сохранить'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

function ExpenseRow({ exp }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: 12, borderBottom: '0.5px solid #f0f0ec' }}>
      <div>
        <div style={{ color: '#444' }}>{exp.category || '—'}</div>
        {exp.comment && <div style={{ fontSize: 11, color: '#999' }}>{exp.comment.includes(':') ? exp.comment.slice(exp.comment.indexOf(':') + 1).trim() : exp.comment}</div>}
      </div>
      <span style={{ fontWeight: 500, color: '#1a1a1a', flexShrink: 0, marginLeft: 8 }}>{parseFloat(exp.amount || 0).toLocaleString('ru-RU')} ₽</span>
    </div>
  )
}

function ExpensesBlock({ expenses, total }) {
  const [open, setOpen] = useState(false)

  const regular = [...expenses].filter(e => e.category !== 'Оформление в Москве').sort((a, b) => (a.date || '').localeCompare(b.date || ''))
  const moscow = [...expenses].filter(e => e.category === 'Оформление в Москве').sort((a, b) => (a.date || '').localeCompare(b.date || ''))
  const moscowTotal = moscow.reduce((s, e) => s + (parseFloat(e.amount) || 0), 0)

  return (
    <div className="route-block" style={{ marginBottom: 10 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }} onClick={() => setOpen(o => !o)}>
        <div className="route-label" style={{ margin: 0 }}>Расходы</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 13, fontWeight: 600, color: '#639922' }}>{total.toLocaleString('ru-RU')} ₽</span>
          <span style={{ fontSize: 12, color: '#aaa' }}>{open ? '▲' : '▼'}</span>
        </div>
      </div>
      {open && (
        <div style={{ marginTop: 8 }}>
          {regular.map((exp, i) => <ExpenseRow key={i} exp={exp} />)}

          {moscow.length > 0 && (
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '10px 0 6px', opacity: 0.5 }}>
                <div style={{ flex: 1, height: 1, background: '#d0d0cc' }} />
                <span style={{ fontSize: 10, fontWeight: 600, color: '#888', textTransform: 'uppercase', letterSpacing: '0.06em', whiteSpace: 'nowrap' }}>🏛 Оформление в Москве</span>
                <div style={{ flex: 1, height: 1, background: '#d0d0cc' }} />
              </div>
              {moscow.map((exp, i) => <ExpenseRow key={'m' + i} exp={exp} />)}
              {regular.length > 0 && (
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: 11, color: '#888', marginTop: 2 }}>
                  <span>Итого МСК</span>
                  <span>{moscowTotal.toLocaleString('ru-RU')} ₽</span>
                </div>
              )}
            </>
          )}

          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', fontSize: 13, fontWeight: 600, marginTop: 4, borderTop: '1px solid #f0f0ec' }}>
            <span>Итого</span>
            <span style={{ color: '#639922' }}>{total.toLocaleString('ru-RU')} ₽</span>
          </div>
        </div>
      )}
    </div>
  )
}

const STATUSES = ['ожидает', 'в пути', 'прибыл', 'завершен']
const FLAGS = ['', '🔴', '🟡', '🟢', '⭐', '❗']

export function DetailModal({ candidate: c, location, statusColors, onEdit, onDelete, onClose, canEdit, canDelete, onArchive, onMoveToSpecial, onMoveToMain, currentUserId, isAdmin, isOperator, isMoscowOperator, currentUser, onBack, initialTab, locations, onUpdateCandidate, agents = [] }) {
  const color = statusColors[c.status] || '#aaa'
  const route = (Array.isArray(c.route) ? c.route : []).filter(p => p.from && p.to)
  const tz = location?.timezone || 'Europe/Moscow'
  const isMoscow = location?.name?.toLowerCase().includes('москва') || tz === 'Europe/Moscow'
  const [tickets, setTickets] = useState([])
  const [ticketsLoading, setTicketsLoading] = useState(true)
  const [activeTab, setActiveTab] = useState(isMoscowOperator ? 'moscow' : (initialTab || 'details'))
  const [saving, setSaving] = useState(false)
  const [photoUploading, setPhotoUploading] = useState(false)
  const [passportUploading, setPassportUploading] = useState(false)
  const [editingQuestionnaire, setEditingQuestionnaire] = useState(false)
  const [questionnaireOpen, setQuestionnaireOpen] = useState(false)
  const [questionnaireText, setQuestionnaireText] = useState(c.questionnaire_text || '')
  const [savingQuestionnaire, setSavingQuestionnaire] = useState(false)
  const [editingName, setEditingName] = useState(false)
  const [nameValue, setNameValue] = useState(c.name || '')
  const [editingPassport, setEditingPassport] = useState(false)
  const [passportValue, setPassportValue] = useState(c.passport || '')
  const [editingPhone, setEditingPhone] = useState(false)
  const [phoneValue, setPhoneValue] = useState(c.phone || '')
  const [candidateTasks, setCandidateTasks] = useState([])
  const [taskInput, setTaskInput] = useState('')
  const [taskSaving, setTaskSaving] = useState(false)

  useEffect(() => {
    fetchCandidateTasks(c.id).then(setCandidateTasks).catch(() => {})
  }, [c.id])
  const photoInputRef = useRef(null)
  const passportInputRef = useRef(null)

  async function handlePhotoUpload(e) {
    const file = e.target.files[0]
    if (!file) return
    setPhotoUploading(true)
    try {
      const url = await uploadPhoto(file, c.id)
      await onUpdateCandidate(c.id, { photo_url: url })
    } catch (err) { alert('Ошибка загрузки фото: ' + err.message) }
    setPhotoUploading(false)
    e.target.value = ''
  }

  async function handlePassportPhotoUpload(e) {
    const files = Array.from(e.target.files)
    if (!files.length) return
    setPassportUploading(true)
    try {
      const uploaded = await Promise.all(files.map(f => uploadRouteFile(f, c.id, 'passport')))
      const updated = [...(c.passport_photos || []), ...uploaded]
      await onUpdateCandidate(c.id, { passport_photos: updated })
    } catch (err) { alert('Ошибка загрузки: ' + err.message) }
    setPassportUploading(false)
    e.target.value = ''
  }

  async function handlePassportPhotoDelete(idx) {
    const updated = (c.passport_photos || []).filter((_, i) => i !== idx)
    await onUpdateCandidate(c.id, { passport_photos: updated })
  }

  async function handleSaveQuestionnaire() {
    setSavingQuestionnaire(true)
    try {
      await onUpdateCandidate(c.id, { questionnaire_text: questionnaireText })
      setEditingQuestionnaire(false)
    } catch (err) { alert('Ошибка: ' + err.message) }
    setSavingQuestionnaire(false)
  }

  async function handleFieldUpdate(field, value) {
    if (!onUpdateCandidate) return
    setSaving(true)
    try { await onUpdateCandidate(c.id, { [field]: value }) } catch (e) { alert('Ошибка: ' + e.message) }
    setSaving(false)
  }

  const isViewer = currentUser?.role === 'viewer'
  const showMoscowTab = isMoscow && (isAdmin || isMoscowOperator || isViewer)

React.useEffect(() => {
    fetchTickets().then(all => {
      setTickets(all.filter(t => t.candidate_id === c.id))
      setTicketsLoading(false)
    }).catch(() => setTicketsLoading(false))
  }, [c.id])

async function handleStatusChange(ticketId, newStatus) {
try {      const updates = { refund_status: newStatus }
      if (newStatus === 'Возврат') updates.refund_date = new Date().toISOString().split('T')[0]
      await updateTicket(ticketId, updates)
      setTickets(prev => prev.map(t => t.id === ticketId ? { ...t, ...updates } : t))
    } catch (e) { alert('Ошибка: ' + e.message) }
  }

  function formatDT(date, time, timezone) {
    if (!date) return null
    try {
      const timeStr = time ? time.slice(0, 5) : '00:00'
      const [year, month, day] = date.split('-').map(Number)
      const [hours, minutes] = timeStr.split(':').map(Number)
      const dt = new Date(Date.UTC(year, month - 1, day, hours, minutes))
      const d = new Intl.DateTimeFormat('ru-RU', { timeZone: 'UTC', day: '2-digit', month: '2-digit', year: 'numeric' }).format(dt)
      const t = new Intl.DateTimeFormat('ru-RU', { timeZone: 'UTC', hour: '2-digit', minute: '2-digit' }).format(dt)
      return time ? d + ' ' + t : d
    } catch (e) { return date }
  }

  function TimeBlock({ date, time, tz: tzProp }) {
    if (!date) return <div style={{ fontSize: 12, color: '#bbb' }}>—</div>
    const localTz = tzProp || 'Europe/Moscow'
    const isLocalMoscow = localTz === 'Europe/Moscow'
    const local = formatDT(date, time, localTz)
    const msk = isLocalMoscow ? null : (() => {
      try {
        const timeStr = time ? time.slice(0, 5) : '00:00'
        const [year, month, day] = date.split('-').map(Number)
        const [h, m] = timeStr.split(':').map(Number)
        const localDt = new Date(Date.UTC(year, month - 1, day, h, m))
        const getOffsetMin = (tz) => {
          const parts = new Intl.DateTimeFormat('en', { timeZone: tz, timeZoneName: 'longOffset' }).formatToParts(localDt)
          const s = parts.find(p => p.type === 'timeZoneName')?.value || 'GMT+00:00'
          const match = s.match(/GMT([+-])(\d+):(\d+)/)
          if (!match) return 0
          return (match[1] === '+' ? 1 : -1) * (parseInt(match[2]) * 60 + parseInt(match[3]))
        }
        const diffMin = getOffsetMin('Europe/Moscow') - getOffsetMin(localTz)
        const mskDt = new Date(localDt.getTime() + diffMin * 60000)
        const d = new Intl.DateTimeFormat('ru-RU', { timeZone: 'UTC', day: '2-digit', month: '2-digit', year: 'numeric' }).format(mskDt)
        const t = new Intl.DateTimeFormat('ru-RU', { timeZone: 'UTC', hour: '2-digit', minute: '2-digit' }).format(mskDt)
        return time ? d + ' ' + t : d
      } catch(e) { return null }
    })()
    return (
      <div style={{ display: 'grid', gridTemplateColumns: isLocalMoscow ? '1fr' : 'minmax(0,1fr) minmax(0,1fr)', gap: 8, background: '#f9f9f7', borderRadius: 8, padding: '6px 10px', marginTop: 4, overflow: 'hidden' }}>
        <div>
          <div style={{ fontSize: 10, color: '#aaa', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 2 }}>Местное</div>
          <div style={{ fontSize: 13, fontWeight: 500, color: '#1a1a1a' }}>{local}</div>
        </div>
        {!isLocalMoscow && msk && (
          <div style={{ borderLeft: '1px solid #efefec', paddingLeft: 8 }}>
            <div style={{ fontSize: 10, color: '#aaa', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 2 }}>МСК</div>
            <div style={{ fontSize: 13, fontWeight: 500, color: '#378ADD', wordBreak: 'break-word' }}>{msk}</div>
          </div>
        )}
      </div>
    )
  }

  return (
    <div className="modal-backdrop">
      <div className="modal modal-sm" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          {onBack && <button onClick={onBack} style={{ background: 'transparent', border: 'none', cursor: 'pointer', fontSize: 18, color: '#888', marginRight: 8, padding: '2px 4px' }}>←</button>}
          <h2>Карточка кандидата</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
        <div className="detail-body">
          {showMoscowTab && (
            <div style={{ display: 'flex', gap: 0, marginBottom: 16, borderBottom: '1px solid #f0f0ec' }}>
              {[
                { key: 'details', label: 'Детали' },
                { key: 'moscow', label: '🏛 Оформление' },
                { key: 'docs', label: '📁 Документы' },
              ].map(tab => (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  style={{
                    fontSize: 12, padding: '7px 12px', border: 'none', cursor: 'pointer',
                    background: 'transparent', fontWeight: activeTab === tab.key ? 600 : 400,
                    color: activeTab === tab.key ? '#1a1a1a' : '#888',
                    borderBottom: activeTab === tab.key ? '2px solid #1a1a1a' : '2px solid transparent',
                    marginBottom: -1, whiteSpace: 'nowrap',
                  }}
                >{tab.label}</button>
              ))}
            </div>
          )}

          {activeTab === 'moscow' && showMoscowTab ? (
            <MoscowPipeline
              candidate={c}
              currentUser={currentUser || { id: currentUserId, full_name: '', role: isMoscowOperator ? 'moscow_operator' : isViewer ? 'viewer' : (isAdmin ? 'admin' : 'operator') }}
              onExpenseAdded={() => {}}
              onComplete={() => {
                if (onUpdateCandidate) onUpdateCandidate(c.id, { moscow_completed: true, moscow_completed_at: new Date().toISOString() })
                onClose()
              }}
            />
          ) : activeTab === 'docs' && showMoscowTab ? (
            <MoscowDocuments candidate={c} />
          ) : (
          <>
          <div className="detail-top">
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0, gap: 4 }}>
              <div style={{ cursor: onUpdateCandidate ? 'pointer' : 'default', position: 'relative' }}
                onClick={() => onUpdateCandidate && !photoUploading && photoInputRef.current?.click()}>
                <div className="detail-avatar">
                  {c.photo_url ? <img src={c.photo_url} alt={c.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <span style={{ fontSize: 24, color: '#999' }}>👤</span>}
                  {onUpdateCandidate && (
                    <div style={{ position: 'absolute', inset: 0, borderRadius: '50%', background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: photoUploading ? 1 : 0, transition: 'opacity 0.15s' }}
                      onMouseOver={e => !photoUploading && (e.currentTarget.style.opacity = 1)}
                      onMouseOut={e => !photoUploading && (e.currentTarget.style.opacity = 0)}>
                      <span style={{ fontSize: 18, color: 'white' }}>{photoUploading ? '...' : '📷'}</span>
                    </div>
                  )}
                </div>
              </div>
              {onUpdateCandidate && <input ref={photoInputRef} type="file" accept="image/*" onChange={handlePhotoUpload} style={{ display: 'none' }} disabled={photoUploading} />}
              {c.photo_url && (
                <a href={c.photo_url} target="_blank" rel="noreferrer"
                  style={{ fontSize: 11, color: '#185FA5', textDecoration: 'none' }}
                  title="Открыть фото">⬇ фото</a>
              )}
            </div>
            <div style={{ flex: 1 }}>
              {editingName ? (
                <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginBottom: 4 }}>
                  <input value={nameValue} onChange={e => setNameValue(e.target.value.toUpperCase())} style={{ fontSize: 15, fontWeight: 600, padding: '4px 8px', borderRadius: 8, border: '1px solid #378ADD', flex: 1 }} autoFocus />
                  <button onClick={async () => { if (!nameValue.trim()) return; await handleFieldUpdate('name', nameValue.trim()); setEditingName(false) }} style={{ fontSize: 12, padding: '4px 10px', borderRadius: 6, border: 'none', background: '#1a1a1a', color: 'white', cursor: 'pointer' }}>✓</button>
                  <button onClick={() => { setNameValue(c.name); setEditingName(false) }} style={{ fontSize: 12, padding: '4px 8px', borderRadius: 6, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer' }}>✕</button>
                </div>
              ) : (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <div className="detail-name">{c.name}</div>
                  {canEdit && <button onClick={() => { setNameValue(c.name); setEditingName(true) }} style={{ fontSize: 11, padding: '2px 7px', borderRadius: 5, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', color: '#666', flexShrink: 0 }}>✏ имя</button>}
                </div>
              )}
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 6 }}>
                <select value={c.status || ''} disabled={saving || !canEdit} onChange={e => handleFieldUpdate('status', e.target.value)}
                  style={{ fontSize: 12, padding: '4px 8px', borderRadius: 8, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer' }}>
                  {STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
                <select value={c.location_id || ''} disabled={saving || !canEdit} onChange={e => handleFieldUpdate('location_id', e.target.value)}
                  style={{ fontSize: 12, padding: '4px 8px', borderRadius: 8, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', maxWidth: 140 }}>
                  {(locations || []).map(l => <option key={l.id} value={l.id}>{l.name}</option>)}
                </select>
                <select value={c.flag || ''} disabled={saving || !canEdit} onChange={e => handleFieldUpdate('flag', e.target.value)}
                  style={{ fontSize: 12, padding: '4px 8px', borderRadius: 8, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer' }}>
                  {FLAGS.map(f => <option key={f} value={f}>{f || '— флаг —'}</option>)}
                </select>
              </div>
            </div>
          </div>

          {c.departure_info && (
            <div style={{ background: '#E6F1FB', border: '1px solid #378ADD44', borderRadius: 10, padding: '10px 14px', marginBottom: 12, display: 'flex', alignItems: 'center', gap: 10 }}>
              <span style={{ fontSize: 20 }}>✈️</span>
              <div>
                <div style={{ fontSize: 12, fontWeight: 600, color: '#0C447C' }}>ВЫЛЕТ ПОДТВЕРЖДЁН</div>
                {c.departure_info.flight && <div style={{ fontSize: 12, color: '#185FA5' }}>Рейс: {c.departure_info.flight}</div>}
                <div style={{ fontSize: 11, color: '#378ADD' }}>
                  {c.departure_info.confirmed_by && `Подтвердил: ${c.departure_info.confirmed_by} · `}
                  {c.departure_info.confirmed_at && new Date(c.departure_info.confirmed_at).toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                </div>
              </div>
            </div>
          )}
          <table className="detail-table">
            <tbody>
              {c.entry_date && <tr><td>Дата добавления</td><td>{String(c.entry_date).slice(0,10).split('-').reverse().join('.')}</td></tr>}
              <tr><td>Гражданство</td><td>
                {onUpdateCandidate ? (
                  <CitizenshipInput
                    value={c.citizenship || ''}
                    onChange={async val => {
                      if (!val || val === c.citizenship) return
                      setSaving(true)
                      try { await onUpdateCandidate(c.id, { citizenship: val }) }
                      catch (err) { alert('Ошибка: ' + err.message) }
                      setSaving(false)
                    }}
                  />
                ) : (c.citizenship || '—')}
              </td></tr>
              {c.city && <tr><td>Город</td><td>{c.city}</td></tr>}
              <tr><td>Паспорт</td><td>
                {canEdit && editingPassport ? (
                  <span style={{ display: 'flex', gap: 4 }}>
                    <input type="text" inputMode="text" autoComplete="off" autoFocus value={passportValue} onChange={e => setPassportValue(e.target.value)}
                      onKeyDown={async e => {
                        if (e.key === 'Enter') { setSaving(true); try { await onUpdateCandidate(c.id, { passport: passportValue }) } catch(err) { alert(err.message) } setSaving(false); setEditingPassport(false) }
                        if (e.key === 'Escape') setEditingPassport(false)
                      }}
                      style={{ fontSize: 13, padding: '2px 6px', borderRadius: 5, border: '1px solid #378ADD', outline: 'none', width: 140 }} />
                    <button onClick={async () => { setSaving(true); try { await onUpdateCandidate(c.id, { passport: passportValue }) } catch(err) { alert(err.message) } setSaving(false); setEditingPassport(false) }}
                      style={{ fontSize: 11, padding: '2px 7px', borderRadius: 5, border: 'none', background: '#378ADD', color: 'white', cursor: 'pointer' }}>✓</button>
                    <button onClick={() => setEditingPassport(false)}
                      style={{ fontSize: 11, padding: '2px 7px', borderRadius: 5, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer' }}>✕</button>
                  </span>
                ) : (
                  <span style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                    {c.passport || '—'}
                    {canEdit && <button onClick={() => { setPassportValue(c.passport || ''); setEditingPassport(true) }} style={{ fontSize: 11, padding: '2px 7px', borderRadius: 5, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', color: '#666' }}>✏</button>}
                  </span>
                )}
              </td></tr>
              <tr><td>Телефон</td><td>
                {canEdit && editingPhone ? (
                  <span style={{ display: 'flex', gap: 4 }}>
                    <input autoFocus value={phoneValue} onChange={e => setPhoneValue(e.target.value)}
                      onKeyDown={async e => {
                        if (e.key === 'Enter') { setSaving(true); try { await onUpdateCandidate(c.id, { phone: phoneValue }) } catch(err) { alert(err.message) } setSaving(false); setEditingPhone(false) }
                        if (e.key === 'Escape') setEditingPhone(false)
                      }}
                      style={{ fontSize: 13, padding: '2px 6px', borderRadius: 5, border: '1px solid #378ADD', outline: 'none', width: 140 }} />
                    <button onClick={async () => { setSaving(true); try { await onUpdateCandidate(c.id, { phone: phoneValue }) } catch(err) { alert(err.message) } setSaving(false); setEditingPhone(false) }}
                      style={{ fontSize: 11, padding: '2px 7px', borderRadius: 5, border: 'none', background: '#378ADD', color: 'white', cursor: 'pointer' }}>✓</button>
                    <button onClick={() => setEditingPhone(false)}
                      style={{ fontSize: 11, padding: '2px 7px', borderRadius: 5, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer' }}>✕</button>
                  </span>
                ) : (
                  <span style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                    {c.phone || '—'}
                    {canEdit && <button onClick={() => { setPhoneValue(c.phone || ''); setEditingPhone(true) }} style={{ fontSize: 11, padding: '2px 7px', borderRadius: 5, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', color: '#666' }}>✏</button>}
                  </span>
                )}
              </td></tr>
              <tr><td>Ответственный</td><td>{c.responsible_name || '—'}</td></tr>
              <tr><td>Агент</td><td>
                {onUpdateCandidate && agents.length > 0 ? (
                  <select value={c.agent_id || ''} disabled={saving}
                    onChange={async e => {
                      const agent = agents.find(a => a.id === e.target.value)
                      setSaving(true)
                      try { await onUpdateCandidate(c.id, { agent_id: e.target.value || null, agent_name: agent?.name || null }) }
                      catch (err) { alert('Ошибка: ' + err.message) }
                      setSaving(false)
                    }}
                    style={{ fontSize: 12, padding: '3px 6px', borderRadius: 6, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', maxWidth: 180 }}>
                    <option value="">— без агента —</option>
                    {agents.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
                  </select>
                ) : (c.agent_name || '—')}
              </td></tr>
              {c.archived && c.archive_reason && <tr><td>Причина архива</td><td style={{ color: '#E24B4A' }}>{c.archive_reason}</td></tr>}
            </tbody>
          </table>

          <div className="route-block" style={{ marginBottom: 10 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: questionnaireOpen ? 8 : 0, cursor: 'pointer' }} onClick={() => setQuestionnaireOpen(o => !o)}>
              <div className="route-label" style={{ margin: 0 }}>Анкета {c.questionnaire_text ? <span style={{ fontWeight: 400, color: '#aaa', fontSize: 10 }}>{questionnaireOpen ? '▲ свернуть' : '▼ развернуть'}</span> : <span style={{ fontWeight: 400, color: '#bbb', fontSize: 10 }}>не заполнена</span>}</div>
              {onUpdateCandidate && !editingQuestionnaire && questionnaireOpen && (
                <button onClick={e => { e.stopPropagation(); setQuestionnaireText(c.questionnaire_text || ''); setEditingQuestionnaire(true) }}
                  style={{ fontSize: 11, padding: '2px 8px', borderRadius: 5, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', color: '#666' }}>✏ Изменить</button>
              )}
            </div>
            {questionnaireOpen && (editingQuestionnaire ? (
              <div>
                <textarea value={questionnaireText} onChange={e => setQuestionnaireText(e.target.value)}
                  rows={6} style={{ width: '100%', fontSize: 12, padding: '8px 10px', borderRadius: 8, border: '1px solid #e0e0dc', resize: 'vertical', fontFamily: 'inherit', lineHeight: 1.6, boxSizing: 'border-box' }} />
                <div style={{ display: 'flex', gap: 6, marginTop: 6 }}>
                  <button onClick={handleSaveQuestionnaire} disabled={savingQuestionnaire}
                    style={{ fontSize: 12, padding: '5px 14px', borderRadius: 7, border: 'none', background: '#1a1a1a', color: 'white', cursor: 'pointer', fontWeight: 600 }}>
                    {savingQuestionnaire ? 'Сохранение...' : 'Сохранить'}
                  </button>
                  <button onClick={() => setEditingQuestionnaire(false)}
                    style={{ fontSize: 12, padding: '5px 12px', borderRadius: 7, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', color: '#888' }}>Отмена</button>
                </div>
              </div>
            ) : (
              <div style={{ fontSize: 12, color: '#444', whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>
                {c.questionnaire_text}
              </div>
            ))}
          </div>

          <div className="route-block" style={{ marginBottom: 10 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
              <div className="route-label" style={{ margin: 0 }}>Фото паспорта</div>
              {onUpdateCandidate && (
                <>
                  <button onClick={() => !passportUploading && passportInputRef.current?.click()}
                    style={{ fontSize: 11, padding: '2px 8px', borderRadius: 5, border: '1px solid #e0e0dc', background: 'white', cursor: 'pointer', color: '#666' }}
                    disabled={passportUploading}>
                    {passportUploading ? 'Загрузка...' : '+ Прикрепить'}
                  </button>
                  <input ref={passportInputRef} type="file" multiple accept="image/*,.pdf" onChange={handlePassportPhotoUpload} style={{ display: 'none' }} disabled={passportUploading} />
                </>
              )}
            </div>
            {(!c.passport_photos || c.passport_photos.length === 0) && (
              <div style={{ fontSize: 12, color: '#bbb' }}>Файлы не прикреплены</div>
            )}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
              {(c.passport_photos || []).map((f, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 4, background: '#fafaf8', border: '1px solid #efefec', borderRadius: 7, padding: '4px 8px' }}>
                  <a href={f.url} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: '#185FA5', textDecoration: 'none' }}>📄 {f.name}</a>
                  {onUpdateCandidate && (
                    <button onClick={() => handlePassportPhotoDelete(i)} style={{ background: 'none', border: 'none', color: '#E24B4A', cursor: 'pointer', fontSize: 13, padding: '0 2px', lineHeight: 1 }}>✕</button>
                  )}
                </div>
              ))}
            </div>
          </div>

          {c.visas && c.visas.length > 0 && (
            <div className="route-block" style={{ marginBottom: 10 }}>
              <div className="route-label">Визы</div>
              {c.visas.map((visa, i) => (
                <div key={i} style={{ marginBottom: 8 }}>
                  <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 4 }}>🛂 {visa.name || 'Виза ' + (i+1)}</div>
                  {visa.submission_date && <div style={{ fontSize: 11, color: '#888', marginBottom: 2 }}>Дата подачи: {String(visa.submission_date).slice(0,10).split('-').reverse().join('.')}</div>}
                  {visa.application_number && <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>№ заявки: {visa.application_number}</div>}
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                    {(visa.files || []).map((f, fi) => (
                      <a key={fi} href={f.url} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: '#185FA5', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 4 }}>📄 {f.name}</a>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}

          {c.expenses && c.expenses.length > 0 && (() => {
            const visibleExpenses = isAdmin ? c.expenses : c.expenses.filter(e => e.operator_id === currentUserId)
            if (visibleExpenses.length === 0) return null
            return <ExpensesBlock expenses={visibleExpenses} total={visibleExpenses.reduce((sum, e) => sum + (parseFloat(e.amount) || 0), 0)} />
          })()}

          {(candidateTasks.length > 0 || canEdit) && (
            <div className="route-block" style={{ marginBottom: 10 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                <div className="route-label" style={{ margin: 0 }}>Задачи</div>
                <button onClick={() => fetchCandidateTasks(c.id).then(setCandidateTasks).catch(() => {})}
                  style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 13, color: '#aaa', padding: '0 2px' }} title="Обновить">↻</button>
              </div>
              {candidateTasks.map(task => {
                const overdue = task.due_date && new Date(task.due_date) < new Date(new Date().toDateString())
                return (
                  <div key={task.id} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', padding: '5px 0', borderBottom: '0.5px solid #f5f5f3', borderLeft: task.priority === 'urgent' ? '3px solid #E24B4A' : 'none', paddingLeft: task.priority === 'urgent' ? 6 : 0 }}>
                    <button onClick={async () => {
                      const isDone = task.status === 'done'
                      await updateTask(task.id, isDone ? { status: 'open', completed_at: null } : { status: 'done', completed_at: new Date().toISOString() })
                      setCandidateTasks(prev => prev.map(t => t.id === task.id ? { ...t, status: isDone ? 'open' : 'done' } : t))
                    }} style={{ width: 18, height: 18, borderRadius: '50%', border: `2px solid ${task.status === 'done' ? '#639922' : '#ccc'}`, background: task.status === 'done' ? '#639922' : 'white', cursor: 'pointer', flexShrink: 0, marginTop: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }} title={task.status === 'done' ? 'Вернуть' : 'Выполнено'}>
                      {task.status === 'done' && <span style={{ color: 'white', fontSize: 10, fontWeight: 700 }}>✓</span>}
                    </button>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 12, fontWeight: 500, color: task.status === 'done' ? '#aaa' : '#1a2332', textDecoration: task.status === 'done' ? 'line-through' : 'none' }}>{task.title}</div>
                      {task.due_date && task.status !== 'done' && <div style={{ fontSize: 11, color: overdue ? '#E24B4A' : '#aaa' }}>{overdue ? '⚠ ' : ''}до {new Date(task.due_date).toLocaleDateString('ru-RU')}</div>}
                    </div>
                  </div>
                )
              })}
              {canEdit && (
                <div style={{ display: 'flex', gap: 6, marginTop: 6 }}>
                  <input value={taskInput} onChange={e => setTaskInput(e.target.value)}
                    onKeyDown={async e => {
                      if (e.key !== 'Enter' || !taskInput.trim()) return
                      setTaskSaving(true)
                      try {
                        const t = await addTask({ title: taskInput.trim(), candidate_id: c.id, candidate_name: c.name })
                        setCandidateTasks(prev => [...prev, t])
                        setTaskInput('')
                      } catch(err) { alert(err.message) }
                      setTaskSaving(false)
                    }}
                    placeholder="Новая задача... (Enter)" style={{ flex: 1, fontSize: 12, padding: '5px 8px', borderRadius: 6, border: '1px solid #e0e0dc', outline: 'none' }} />
                </div>
              )}
            </div>
          )}

          {tickets.length > 0 && (
            <div className="route-block" style={{ marginBottom: 10 }}>
              <div className="route-label">Билеты</div>
              {tickets.map(t => (
                <div key={t.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 0', borderBottom: '0.5px solid #f5f5f3', gap: 8 }}>
                  <div style={{ fontSize: 12 }}>
                    <div style={{ fontWeight: 500 }}>{t.from_city} → {t.to_city}</div>
                    <div style={{ color: '#888', fontSize: 11 }}>{t.departure_date ? String(t.departure_date).slice(0,10).split('-').reverse().join('.') : ''}</div>
                  </div>
                  {canEdit ? (
                    <select value={t.refund_status || ''} onChange={e => handleStatusChange(t.id, e.target.value)} style={{ fontSize: 12, padding: '4px 8px', borderRadius: 6, border: '1px solid #e0e0dc' }}>
                      <option value="">В процессе</option>
                      <option value="Успех">Успех (долетел)</option>
                      <option value="Возврат">Возврат (не долетел)</option>
                    </select>
                  ) : (
                    <span style={{ fontSize: 11, padding: '3px 8px', borderRadius: 6, background: t.refund_status === 'Возврат' ? '#FCEBEB' : t.refund_status === 'Успех' ? '#EAF3DE' : '#FAEEDA', color: t.refund_status === 'Возврат' ? '#E24B4A' : t.refund_status === 'Успех' ? '#27500A' : '#633806' }}>
                      {t.refund_status || 'В процессе'}
                    </span>
                  )}
                </div>
              ))}
            </div>
          )}

          <div className="route-block">
            <div className="route-label">Маршрут</div>
            {route.length === 0 && <div style={{ fontSize: 12, color: '#999' }}>Маршрут не указан</div>}
            {(() => {
              const groups = []
              route.forEach(point => {
                const tid = point.ticket_id
                if (tid) {
                  const existing = groups.find(g => g.ticket_id === tid)
                  if (existing) { existing.points.push(point); return }
                }
                groups.push({ ticket_id: tid || null, points: [point], is_return: point.is_return, transport_type: point.transport_type })
              })
              return groups.map((group, gi) => {
                const isReturn = group.is_return
                const isBus = group.transport_type === 'автобус'
                const icon = isBus ? '🚌' : '✈'
                const allFiles = group.points.flatMap(p => p.files || []).filter((f, i, arr) => arr.findIndex(x => x.url === f.url) === i)
                return (
                  <div key={gi} style={{ marginBottom: 14 }}>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <div style={{ width: 20, height: 20, borderRadius: '50%', background: '#1a1a1a', color: 'white', fontSize: 10, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: 2 }}>{gi + 1}</div>
                      <div style={{ flex: 1 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6 }}>
                          {isReturn && <span style={{ fontSize: 10, fontWeight: 600, padding: '1px 6px', borderRadius: 10, background: '#E6F1FB', color: '#0C447C' }}>обратный</span>}
                        </div>
                        {group.points.map((point, pi) => (
                          <div key={pi}>
                            {pi > 0 && <div style={{ borderTop: '1px dashed #e0e0dc', margin: '8px 0', borderStyle: 'dashed' }} />}
                            <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 2 }}>{icon} {point.from || '—'}</div>
                            <TimeBlock date={point.from_date} time={point.from_time} tz={point.from_tz} />
                            <div style={{ textAlign: 'center', color: '#ccc', fontSize: 16, margin: '6px 0' }}>↓</div>
                            <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 2 }}>🛬 {point.to || '—'}</div>
                            <TimeBlock date={point.to_date} time={point.to_time} tz={point.to_tz} />
                          </div>
                        ))}
                        <div style={{ marginTop: 6, display: 'flex', flexWrap: 'wrap', gap: 4, alignItems: 'center' }}>
                          {allFiles.map((f, fi) => (
                            <span key={fi} className="file-chip" style={{ display: 'inline-flex', alignItems: 'center', gap: 2, background: '#f0f4fa', borderRadius: 4, padding: '1px 5px' }}>
                              <a href={f.url} target="_blank" rel="noreferrer" className="file-chip-link" style={{ fontSize: 11, color: '#185FA5', textDecoration: 'none' }}>📎 {f.name}</a>
                              {canEdit && onUpdateCandidate && (
                                <button onClick={async () => {
                                  if (!window.confirm('Удалить этот файл?')) return
                                  const newRoute = (c.route || []).map(p => {
                                    if (!(p.files || []).some(x => x.url === f.url)) return p
                                    return { ...p, files: (p.files || []).filter(x => x.url !== f.url) }
                                  })
                                  await onUpdateCandidate(c.id, { route: newRoute })
                                }} title="Удалить файл" style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#e57373', fontSize: 13, padding: '0 2px', lineHeight: 1 }}>✕</button>
                              )}
                            </span>
                          ))}
                          {canEdit && onUpdateCandidate && (
                            <label className="file-add-btn" style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: 11, color: '#185FA5', cursor: 'pointer', background: '#f0f4fa', borderRadius: 4, padding: '2px 7px', border: '1px dashed #b0c8e8' }}>
                              + файл
                              <input type="file" style={{ display: 'none' }} onChange={async e => {
                                const file = e.target.files[0]
                                if (!file) return
                                e.target.value = ''
                                try {
                                  const uploaded = await uploadRouteFile(file, c.id, `g${gi}_${Date.now()}`)
                                  const firstPoint = group.points[0]
                                  let patched = false
                                  const newRoute = (c.route || []).map(p => {
                                    if (!patched && p === firstPoint) { patched = true; return { ...p, files: [...(p.files || []), uploaded] } }
                                    return p
                                  })
                                  await onUpdateCandidate(c.id, { route: newRoute })
                                } catch (err) { alert('Ошибка загрузки: ' + err.message) }
                              }} />
                            </label>
                          )}
                        </div>
                      </div>
                    </div>
                    {gi < groups.length - 1 && <div style={{ borderTop: '1px dashed #efefec', margin: '10px 0 0 28px' }} />}
                  </div>
                )
              })
            })()}
          </div>
          </>
          )}
        </div>
        <div className="modal-actions" style={{ flexWrap: 'wrap', gap: 6 }}>
          {canDelete && !isMoscowOperator && <button className="btn btn-danger" onClick={onDelete}>Удалить</button>}
          {canEdit && !isMoscowOperator && <button className="btn btn-outline" onClick={onArchive} style={{ borderColor: '#EF9F27', color: '#EF9F27', fontSize: 12, padding: '6px 10px' }}>{c.archived ? '📤 Восстановить' : '📦 В архив'}</button>}
          {onMoveToSpecial && <button className="btn btn-outline" onClick={onMoveToSpecial} style={{ borderColor: '#7c5fe6', color: '#7c5fe6', fontSize: 12, padding: '6px 10px', fontWeight: 600 }}>🔒 В особую</button>}
          {onMoveToMain && <button className="btn btn-outline" onClick={onMoveToMain} style={{ borderColor: '#7c5fe6', color: '#7c5fe6', fontSize: 12, padding: '6px 10px', fontWeight: 600 }}>↩ В основную</button>}
          <button className="btn btn-outline" onClick={onClose}>Закрыть</button>
        </div>
      </div>
    </div>
  )
}

export default LocationModal